webpackJsonp([152353443630966],{

/***/ 636:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _LoreHookWebsocketsSails = __webpack_require__(109);
	
	var _LoreHookWebsocketsSails2 = _interopRequireDefault(_LoreHookWebsocketsSails);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _LoreHookWebsocketsSails2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'lore-hook-websockets-sails'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Source code for this hook can be found on GitHub ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://github.com/lore/lore/tree/master/packages/lore-hook-websockets-sails' },
	        'at this link'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Purpose'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This hook is built on top of the ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://github.com/lore/lore/tree/master/packages/lore-websockets' },
	        'lore-websockets'
	      ),
	      ' library and implements the interface for Sails.'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Example'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'See the ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://github.com/lore/lore/tree/master/examples/websockets' },
	        'websockets example'
	      ),
	      ' to see this hook in action.'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Example Usage'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The Sails hook behaves identical to the SocketIO hook, except for the implementation. The big callout here is that you need to install both the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'socket.io-client'
	      ),
	      ' ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'and'
	      ),
	      ' the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'sails.io.js'
	      ),
	      ' package (that takes the socket.io client as an argument).'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'You also need to set the URL ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'immediately'
	      ),
	      ' after creating this object, as it will try to call out to the server. Alternatively, you can set ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'io.sails.url.authConnect = false'
	      ),
	      '. I\'m still playing with this implementation a bit, but am leaning towards that solution (so that it doesn\'t make ANY server calls until you tell it to).'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The other thing to point out is the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'dispatch'
	      ),
	      ' implementation. For the most part Sails used a message structure consisting of ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'verb'
	      ),
	      ' and ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'data'
	      ),
	      ' fields, but sometimes replaces ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'data'
	      ),
	      ' with ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'previous'
	      ),
	      ' when it comes to updated and deleted data. So the parse method has been modified to convert everything into a verb/data structure.'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      import _ from \'lodash\';\n      import { WebSocketConnection } from \'lore-websockets\';\n      import io from \'socket.io-client\';\n      import SailsIOClient from \'sails.io.js\';\n\n      const SOCKET_VERBS = {\n        CREATED: \'created\',\n        UPDATED: \'updated\',\n        DESTROYED: \'destroyed\',\n        ADDED_TO: \'addedTo\'\n      };\n\n      export default WebSocketConnection.extend({\n\n        // serverUrl: \'http://localhost:1337\',\n        // namespace: \'/posts\',\n        // event: \'post\',\n\n        initialize: function(dispatchers, actions) {\n          this.io = SailsIOClient(io);\n          this.io.sails.url = this.serverUrl;\n        },\n\n        connect: function() {\n          const namespace = this.namespace;\n          // we have to make a GET request to this endpoint before we\'re connected\n          this.io.socket.get(namespace, function() {\n            console.log(`Connected to ${namespace}`);\n          });\n        },\n\n        subscribe: function() {\n          this.io.socket.on(this.event, this.dispatch);\n        },\n\n        unsubscribe: function() {\n          this.io.socket.off(this.event, this.dispatch);\n        },\n\n        parse: function(message) {\n          if (message.verb === SOCKET_VERBS.CREATED) {\n            return {\n              verb: message.verb,\n              data: message.data\n            }\n          } else if (message.verb === SOCKET_VERBS.UPDATED) {\n            return {\n              verb: message.verb,\n              data: message.data\n            }\n          } else if (message.verb === SOCKET_VERBS.DESTROYED) {\n            return {\n              verb: message.verb,\n              data: message.previous\n            }\n          } else if (message.verb === SOCKET_VERBS.ADDED_TO) {\n            return {\n              verb: message.verb,\n              data: message.data\n            }\n          } else {\n            return {\n              verb: \'unknown_verb\',\n              data: message\n            }\n          }\n        }\n\n      });\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-hooks-lore-hook-websockets-sails-index-js-8603487f496988097143.js